import { render, staticRenderFns } from "./AdminTableItem.vue?vue&type=template&id=c117cff2&"
import script from "./AdminTableItem.vue?vue&type=script&lang=js&"
export * from "./AdminTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c117cff2')) {
      api.createRecord('c117cff2', component.options)
    } else {
      api.reload('c117cff2', component.options)
    }
    module.hot.accept("./AdminTableItem.vue?vue&type=template&id=c117cff2&", function () {
      api.rerender('c117cff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/AdminTableItem.vue"
export default component.exports